import { useGridApiContext } from "@mui/x-data-grid";
import { EditableSelectCustomOnChange } from "ui-components/EditableInput2";
import { SelectFields } from "ui-components/Form";
import { Card, Icon, MenuItem, Menu, Divider } from "@mui/material";
import Select from "@mui/material/Select";

export const billingOutboundB2BColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
      {
        field: "lowerLimit",
        headerName: "Range From",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 150,
      },
      {
        field: "upperLimit",
        headerName: "Range To",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 150,
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingOutboundB2CColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "priority",
        headerName: "Priority",
        sortable: false,
        align: "left",
        //flex:1
        width: 150,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 150,
      },
      {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "lowerLimit",
        headerName: "Range From",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 120,
      },
      {
        field: "upperLimit",
        headerName: "Range To",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 120,
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 120,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingReturnColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
      {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "lowerLimit",
        headerName: "Range From",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 150,
      },
      {
        field: "upperLimit",
        headerName: "Range To",
        sortable: false,
        align: "left",
        editable: true,
        type: "number",
        headerClassName: "custom-editable-header",
        width: 150,
      },
    //   {
    //     field: "lowerLimit",
    //     headerName: "Range From",
    //     sortable: false,
    //     align: "left",
    //     editable: true,
    //     type: "number",
    //     headerClassName: "custom-editable-header",
    //     width: 200,
    //   },
    //   {
    //     field: "upperLimit",
    //     headerName: "Range To",
    //     sortable: false,
    //     align: "left",
    //     editable: true,
    //     type: "number",
    //     headerClassName: "custom-editable-header",
    //     width: 200,
    //   },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingInboundColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
       {
         field: "lowerLimit",
         headerName: "Range From",
         sortable: false,
         align: "left",
         editable: true,
         type: "number",
         headerClassName: "custom-editable-header",
         width: 150,
       },
       {
         field: "upperLimit",
         headerName: "Range To",
         sortable: false,
         align: "left",
         editable: true,
         type: "number",
         headerClassName: "custom-editable-header",
         width: 150,
       },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingStorageColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingStuffingUnstuffingColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingVASColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

   export const billingPackagingMaterialColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingManagementFeesColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };

  export const billingOTColumns = (zoneOptions, zoneObj, setEditing, viewPricePermission) => {
    const Cell = ({ params }) => {
      //setZoneID(params.row.toZone)
      const apiRef = useGridApiContext();
 
      const { id, field, value } = params;
      console.log("id field and value in columns",{ id, field, value });
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneOptions}
        />
      );
    };
    const LocationCell = ({ params }) => {
      //console.log(params.row.toZone)
      const apiRef = useGridApiContext();
      const { id, field, value, row } = params;
  
      const onChange = (e, option) => {
        setEditing(true);
        apiRef.current.setEditCellValue({
          id,
          field,
          value: option,
        });
      };
  
      return (
        <EditableSelectCustomOnChange
          disableClearable={true}
          getValue={() => value ?? null}
          onChange={onChange}
          options={zoneObj[row.to_zone] ?? []}
        />
      );
    };
    return [
    //   {
    //     field: "sku_code",
    //     headerName: "SKU Code",
    //     sortable: false,
    //     align: "left",
    //     flex: 1,
    //     //width: 220,
    //   },
    //   {
    //     field: "order_quantity",
    //     headerName: "Order Qty",
    //     sortable: false,
    //     align: "right",
    //     width: 120,
    //   },
    //   {
    //     field: "id",
    //     headerName: "ID",
    //     sortable: false,
    //     align: "left",
    //     //flex:1,
    //     width: 100,
    //   },
      {
        field: "criteria",
        headerName: "Criteria",
        sortable: false,
        align: "left",
        //flex:1
        width: 650,
        flex: 1,
      },
      {
        field: "chargeType",
        headerName: "Charge Type",
        sortable: false,
        align: "left",
        //flex:1
        width: 200,
      },
    {
        field: "billingParameter",
        headerName: "Parameter Setup",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,   
      },
      {
        field: "rate",
        headerName: "Rate",
        sortable: false,
        align: "left",
        editable: viewPricePermission !== null ? viewPricePermission : false,
        headerClassName: "custom-editable-header",
        width: 150,
        //renderEditCell: (params) => <Cell params={params} />,
        valueFormatter: (params) => {
          if (!viewPricePermission)
            return "**";
        }
      },
      {
        field: "active",
        headerName: "Status",
        sortable: false,
        align: "left",
        editable: true,
        headerClassName: "custom-editable-header",
        width: 100,
        renderEditCell: (params) => (
            <Select
            value={params.value || "Inactive"} // Default value
            onChange={(e) => params.api.setEditCellValue({ id: params.id, field: "active", value: e.target.value })}
            fullWidth
            size="small"
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        ),
        renderCell: (params) => (
          <span style={{ color: params.value === "Active" ? "green" : "red" }}>
            {params.value || "Inactive"}
          </span>
        ),
        //flex: 1,
      }
      
    ];
  };